import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
import increaseService from "data/increase"

const RentNamedItem = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.rentdetail"));
  const increaseOptions = _.map(props.namedItems['increase'], (i) => { return {label: i.code, value: i.increaseid} })
  const rentOptions = _.map(props.namedItems['rent'], (r) => { return {label: r.code, value: r.rentid} })

  const emptyRecord = {
    rentNamedItemId: null,
    increaseNamedItemId: _.get(props, "defaults.rentIncrease.increaseNamedItemId", _.find(increaseService.value(), {code: '*None'})?.increaseid)
  }

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'namedItem') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    setData(nextData);
    props.persist({...nextData, state: 'namedItem'}, 'rentdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('marketlease', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Rent</label>
          <DropdownInput
            className="automated"
            data={data}
            attrs={attrs}
            field="rentNamedItemId"
            filter={true}
            options={rentOptions}
            persist={updateData}
          />
        </div>
        <div>
          <label>Increase</label>
          <DropdownInput
            className="automated named-item-state-input"
            data={data}
            attrs={attrs}
            field="increaseNamedItemId"
            filter={true}
            options={increaseOptions}
            persist={updateData}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default RentNamedItem